import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListCredits(authorization, filter) {
  const url = `${API_URL}/admin/in-web`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addCredits(authorization, data) {
  const url = `${API_URL}/admin/in-web/create`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function editCredits(authorization, data) {
  const url = `${API_URL}/admin/in-web/update`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function deleteCredits(authorization, data) {
  const url = `${API_URL}/admin/in-web/delete`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/creditsamount.js